import { n as _objectSpread2, C as _toConsumableArray, o as createGuid } from './helpers-125bb300.js';
import { h } from 'vue';
import { j as childMixin, f as slotMixin } from './index-f38a9194.js';
import { s as script$2 } from './CalendarNav-71731195.js';
import { s as script$1 } from './Popover.vue_vue&type=style&index=0&id=141fd4b0&lang-35abb1f8.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { a as script$3, g as getPopoverTriggerEvents } from './CalendarDay.vue_vue&type=style&index=0&id=760aefde&lang-9995e1a5.js';

var script = {
  name: 'CalendarPane',
  emits: ['update:page'],
  mixins: [childMixin, slotMixin],
  inheritAttrs: false,
  render: function render() {
    var _this = this;

    // Header
    var header = this.safeSlot('header', this.page) || // Default header
    h('div', {
      class: "vc-header align-".concat(this.titlePosition)
    }, [// Header title
    h('div', _objectSpread2({
      class: 'vc-title'
    }, this.navPopoverEvents), [this.safeSlot('header-title', this.page, this.page.title)]), // Navigation popover
    h(script$1, {
      id: this.navPopoverId,
      contentClass: 'vc-nav-popover-container'
    }, {
      // Navigation pane
      default: function _default() {
        return h(script$2, {
          value: _this.page,
          validator: _this.canMove,
          onInput: function onInput($event) {
            return _this.move($event);
          }
        }, _objectSpread2({}, _this.$slots));
      }
    })]); // Weeks

    var weeks = h('div', {
      class: 'vc-weeks'
    }, [].concat(_toConsumableArray(this.weekdayLabels.map(function (wl, i) {
      return h('div', {
        key: i + 1,
        class: 'vc-weekday'
      }, [wl]);
    })), _toConsumableArray(this.page.days.map(function (day) {
      return h(script$3, _objectSpread2(_objectSpread2({}, _this.$attrs), {}, {
        day: day,
        slots: _this.$slots
      }));
    }))));
    return h('div', {
      class: 'vc-pane',
      ref: 'pane'
    }, [header, weeks]);
  },
  props: {
    page: Object,
    titlePosition: String,
    navVisibility: String,
    canMove: {
      type: Function,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      navPopoverId: createGuid()
    };
  },
  computed: {
    navVisibility_: function navVisibility_() {
      return this.propOrDefault('navVisibility', 'navVisibility');
    },
    navPlacement: function navPlacement() {
      switch (this.titlePosition) {
        case 'left':
          return 'bottom-start';

        case 'right':
          return 'bottom-end';

        default:
          return 'bottom';
      }
    },
    navPopoverEvents: function navPopoverEvents() {
      return getPopoverTriggerEvents({
        id: this.navPopoverId,
        visibility: this.navVisibility_,
        placement: this.navPlacement,
        modifiers: [{
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom']
          }
        }],
        isInteractive: true,
        isRenderFn: true
      });
    },
    weekdayLabels: function weekdayLabels() {
      var _this2 = this;

      return this.locale.getWeekdayDates().map(function (d) {
        return _this2.format(d, _this2.masks.weekdays);
      });
    }
  },
  methods: {
    move: function move(page) {
      this.$emit('update:page', page);
    }
  }
};

var css_248z = ".vc-pane {\r\n  min-width: 250px;\n}\n.vc-header {\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-justify-content: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -webkit-align-items: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  padding: 10px 16px 0px 16px;\n}\n.vc-header.align-left {\r\n    -webkit-justify-content: flex-start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\n}\n.vc-header.align-right {\r\n    -webkit-justify-content: flex-end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\n}\n.vc-title {\r\n  font-size: var(--text-lg);\r\n  color: var(--gray-800);\r\n  font-weight: var(--font-semibold);\r\n  line-height: 28px;\r\n  cursor: pointer;\r\n  -webkit-user-select: none;\r\n      -ms-user-select: none;\r\n          user-select: none;\r\n  white-space: nowrap;\n}\n.vc-title:hover {\r\n    opacity: 0.75;\n}\n.vc-weeks {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  position: relative;\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  padding: 6px;\n}\n.vc-weekday {\r\n  text-align: center;\r\n  color: var(--gray-500);\r\n  font-size: var(--text-sm);\r\n  font-weight: var(--font-bold);\r\n  line-height: 14px;\r\n  padding-top: 4px;\r\n  padding-bottom: 8px;\r\n  cursor: default;\r\n  -webkit-user-select: none;\r\n      -ms-user-select: none;\r\n          user-select: none;\n}\n.vc-weekdays {\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\n}\n.vc-nav-popover-container {\r\n  color: var(--white);\r\n  font-size: var(--text-sm);\r\n  font-weight: var(--font-semibold);\r\n  background-color: var(--gray-800);\r\n  border: 1px solid;\r\n  border-color: var(--gray-700);\r\n  border-radius: var(--rounded-lg);\r\n  padding: 4px;\r\n  box-shadow: var(--shadow);\n}\n.vc-is-dark .vc-header {\r\n    color: var(--gray-200);\n}\n.vc-is-dark .vc-title {\r\n    color: var(--gray-100);\n}\n.vc-is-dark .vc-weekday {\r\n    color: var(--accent-200);\n}\n.vc-is-dark .vc-nav-popover-container {\r\n    color: var(--gray-800);\r\n    background-color: var(--white);\r\n    border-color: var(--gray-100);\n}\r\n";
styleInject(css_248z);

export { script as s };
